import {
  Box,
  TextField,
  Card,
  CardContent,
  Typography,
  Button,
  CardHeader,
  Divider,
  Grid,
  Container
} from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import axios from 'axios';
import InputLabel from '@mui/material/InputLabel';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AWS from 'aws-sdk';
import { toast } from 'react-toastify';
import './AddBlog.css'; // Create this CSS file if needed
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

// AWS S3 Configuration
AWS.config.update({
  accessKeyId: 'AKIAWX5OXDFHYFDDAEEF',
  secretAccessKey: '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',
  region: 'ap-south-1'
});

const initialValues = { Title: '', Content: '' };

const validationSchema = Yup.object({
  Title: Yup.string().required('Title is required'),
  Content: Yup.string().required('Content is required')
});

const AddBlog = () => {
  const [image, setImage] = useState(null);
  const [img, setImg] = useState('');
  const [imageErr, setImageErr] = useState(false);
  const [addButton, setAddButton] = useState(false);
  const navigate = useNavigate();
  
  const s3 = new AWS.S3();

  async function handleImageFile(e) {
    setImageErr(false);
    const file = e.target.files[0];
    const folderPath = 'community1/'; 
    if (file) {
      setImage(file.name);
      const params = {
        Bucket: 'chaturvedi-v2',
        Key: `${folderPath}${Date.now()}_${file.name}`,
        // Key: `${Date.now()}_${file.name}`,
        Body: file,
        ACL: 'public-read', // Ensure this is set according to your permissions
        ContentType: file.type // Set the content type
      };

      try {
        console.log('Uploading to S3...', params);
        const { Location } = await s3.upload(params).promise();
        setImg(Location);
        console.log('Upload successful:', Location);
      } catch (error) {
        console.error('Upload failed:', error);
        toast.error(`Upload failed: ${error.message}`, {
          position: 'bottom-right'
        });
      }
    } else {
      setImageErr(true);
    }
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    
    onSubmit: async (values) => {
      const requestBody = {
        ...values,
        image: img
      };

      try {
        setAddButton(true);
        await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/blogs/addBlog`,
          requestBody
        );
        toast.success('Blog added successfully!', {
          position: 'bottom-right'
        });
        navigate('/blogs/list'); // Navigate after successful submission
      } catch (err) {
        setAddButton(false);
        toast.error(err.response?.data?.message || 'Error adding blog', { position: 'bottom-right' });
      }
    }
  });

  return (
    <Container maxWidth="lg">
        <Card>
    <form onSubmit={formik.handleSubmit} style={{ margin: 30 }}>
      <Grid item xs={12}>
        <Card>
        <CardHeader
      title="Add Blogs"
      titleTypographyProps={{
        style: {
          margin: 0,
          width: '100%',
          color: '#000',
          fontWeight: 700,
          fontSize: '25px',
          marginBottom: '30px'
        }
      }}
    />
        
          <CardContent>
            <Box component="form" noValidate autoComplete="off">
              <div style={{ margin: 9 }}>
                <TextField
                  label="Title"
                  name="Title"
                  type="text"
                  value={formik.values.Title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  fullWidth
                  required
                />
                {formik.errors.Title && formik.touched.Title ? (
                  <p style={{ color: 'red' }}>{formik.errors.Title}</p>
                ) : null}
              </div>

              <div style={{ margin: 9, width: '98%' }}>
                    <ReactQuill
                      value={formik.values.Content}
                      onChange={(Content, delta, source, editor) => {
                        formik.setFieldValue('Content', Content);
                      }}
                      onBlur={() => formik.setFieldTouched('Content', true)}
                      modules={{
                        toolbar: [
                          [{ header: [1, 2, false] }],
                          ['bold', 'italic', 'underline'],
                          [{ color: [] }],
                          ['link'],
                          ['clean']
                        ]
                      }}
                      formats={[
                        'header',
                        'bold',
                        'italic',
                        'underline',
                        'color',
                        'link'
                      ]}
                    />
                    {formik.touched.Content && formik.errors.Content && (
                      <div style={{ color: 'red', marginTop: '5px' }}>
                        {formik.errors.Content}
                      </div>
                    )}
                  </div>


              <div style={{ margin: 9 }}>
                <input type="file" onChange={handleImageFile} />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <AttachFileIcon />
                  <label>choose an Image</label>
                </div>
                {img && <img src={img} alt="Selected" style={{ maxWidth: '170px' }} />}
              </div>
            </Box>
          </CardContent>
        </Card>
      </Grid>
      <div style={{ margin: 9, width: '100%',padding:'14px' }}>
        <Button variant="contained" type="submit" disabled={addButton}>
          Submit
        </Button>
      </div>
    </form>
    </Card>
    </Container>
  );
};

export default AddBlog;
